import React from "react";
import EntryForm from "../components/EntryForm";

export default function TransferEntry() {
  return (
    <div>
      <p className="small-label text-gray-500 mb-4">Move filled cylinders from one godown to another. Receiver sends MT back.</p>
      <EntryForm type="transfer" />
    </div>
  );
}
